<template>
  <div id="textArea">
    <div class="frame-outer" :class="type" :style="frameStyle" @click.capture.stop="onClick">
      <div class="frame-inner">
        <h3 class="frame-tit">{{ title }}</h3>
        <p class="frame-txt" v-html="textVal"></p>
        <div class="arrow" :style="arrowStyle"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'TextArea',
    props: {
      scene: Number,
      title: String,
      txtsrc: String,
      arrow: Boolean,
      type: String
    },
    data() {
      return {
        // publicPath: process.env.BASE_URL,
        frameStyle: {},
        framePink: {
          backgroundImage: 'url(./img/common/pink_frm01_724_t.png),url(./img/common/pink_frm01_724_b.png), url(./img/common/pink_frm01_l.png), url(./img/common/pink_frm01_r.png)'
        },
        frameBlue: {
          backgroundImage: 'url(./img/common/blue_frm01_724_t.png),url(./img/common/blue_frm01_724_b.png), url(./img/common/blue_frm01_l.png), url(./img/common/blue_frm01_r.png)'
        },
        arrowStyle: {},
        arrowPink: {
          backgroundImage: 'url(./img/common/pink_arw.png)'
        },
        arrowBlue: {
          backgroundImage: 'url(./img/common/blue_arw.png)'
        },
        textArray: [],
        textVal: '',
        timer_text: null,
        timer_arrow: null,
        timer_pause: null,
        timer_start: null,
        clickFrag: null,
        prevData: null
      }
    },
    created(){
    },
    mounted(){
      this.updateFrame()
      this.startTxt()
    },
    watch: {
      type() {
        this.updateFrame()
      },
      txtsrc() {
        // this.typeAnim()
      },
      scene(){
        this.startTxt()
      }
    },
    methods: {
      updateFrame: function(){
        if(this.type === 'badend' || this.type === 'badend_story'){
          this.frameStyle = this.frameBlue
          this.arrowStyle = this.arrowBlue
        } else {
          this.frameStyle = this.framePink
          this.arrowStyle = this.arrowPink
        }
      },
      startTxt(){
        this.clickFrag = false

        this.timer_start = setTimeout(function(){
          clearTimeout(this.timer_start)
          this.typeAnim()
        }.bind(this), 600)

        this.resetText()
      },
      resetText(){
        if(this.txtsrc !== this.prevData){
          this.textVal = ''
          clearInterval(this.timer_arrow)
          _$('#textArea .arrow').hide()
        }
      },
      typeAnim: function(){
        if(this.txtsrc !== this.prevData){
          if(this.timer_text){
            this.stopTimer()
            clearTimeout(this.timer_pause)
            _$('#textArea .arrow').hide()
          }
          this.textArray = []
          this.textVal = ''

          if(this.txtsrc){
            let txtsrc_array = this.txtsrc.replace(/<br>/g, ',<br>,').replace(/<span/g, ',<span').replace(/<\/span>/g, '</span>,')
            let array_woBR = txtsrc_array.split(',')
            let allText = ''

            for(let el of array_woBR){
              let joinText = null
              if(el.indexOf('<') === -1){
                joinText = el.split('').join()
              } else {
                joinText = el
              }
              allText += joinText
            }

            this.textArray = allText.split(',')

            let textArray_length = this.textArray.length
            let countNum = 0

            this.timer_text = setInterval(function(){
              this.textVal += this.textArray[countNum]
              countNum++
              if(countNum === textArray_length){
                this.stopTimer()
                // console.log("===== text anim finish =====")
                this.$emit('updateBtns')

                if(this.arrow){
                  // _$('#textArea .arrow').show()
                  this.blinkArrow()
                  this.clickFrag = true
                }
              }
            }.bind(this), 70)

            this.prevData = this.txtsrc
          }
        } else {
          // テキスト内容に変更がない場合
          clearTimeout(this.timer_pause)
          if(!this.arrow){
            this.clickFrag = false
          }
          this.timer_pause = setTimeout(function(){
            clearTimeout(this.timer_pause)
            clearInterval(this.timer_arrow)
            this.$emit('updateBtns')
            if(this.arrow){
              this.blinkArrow()
              this.clickFrag = true
            }
          }.bind(this), 750)
        }
      },
      onClick: function(){
        if(this.arrow && this.clickFrag){
          this.$emit('frameTap');
        }
      },
      blinkArrow: function(){
        this.timer_arrow = setInterval(function(){
          if(this.arrow){
            _$('#textArea .arrow').toggle()
          } else {
            _$('#textArea .arrow').hide()
            clearInterval(this.timer_arrow)
          }
        }.bind(this), 500)
      },
      stopTimer: function(){
        clearInterval(this.timer_text)
        clearInterval(this.timer_arrow)
      }
    },
    destroyed() {
      this.stopTimer()
      clearTimeout(this.timer_pause)
      clearTimeout(this.timer_start)
    }
  }
</script>

<style lang="scss" scoped>
  #textArea {
    .frame-outer {
        background-position: center top, center bottom, left top, right top;
        background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
        background-size: 100% auto, 100% auto, toVW(10) auto, toVW(10) auto;
        width: toVW(724);
        height: toVW(193);
        margin: toVW(20) auto toVW(13);
        position: relative;
        letter-spacing: 0.1em;

        .frame-inner {
            width: 100%;
            height: 100%;
            padding: toVW(40) toVW(75);
            line-height: 1.5;
        }

        &.opening { 
          height: toVW(460);

          .frame-inner {
              padding: toVW(60) toVW(75);
              line-height: 1.8;
          }
        }
        &.ending { 
          height: toVW(543);

          .frame-inner {
              padding: toVW(60) toVW(75);
              line-height: 1.8;
          }
        }

        .frame-tit {
            background: #000;
            color: $COLOR_PINK01;
            font-size: toVW(26);
            line-height: 1.35rem;
            width: auto;
            padding: .3em .5em .3em .8em;
            position: absolute;
            top: toVW(-15);
            left: 50%;
            transform: translateX(-50%);
            user-select: none;
        }

        &.badend,
        &.badend_story {
          .frame-tit {
            color: $COLOR_BLUE01;
          }
        }

        .arrow {
          background-repeat: no-repeat;
          background-size: contain;
          width: toVW(28);
          height: toVW(21);
          position: absolute;
          bottom: toVW(30);
          right: toVW(30);
          display: none;
        }
    }
  }
</style>
